import { useEffect, useState } from "react";
import Input from "../../FormComponents/Input";
import MultiSelectBox from "../../FormComponents/MultiSelectBox";

const OwnerPreFilters = ({ ownerPreFilters, setOwnerPreFilters, tableData }) => {
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [selectNextActivity, setSelectNextActivity] = useState(false);

  const getNextActivities = async () => {
    let tempObj = [];
    tableData?.table?.columns_new?.forEach((activity) => {
      ownerPreFilters.next_activities?.forEach((previousacitivityid) => {
        if (previousacitivityid === activity.activity_id) {
          tempObj.push(activity);
        }
      });
    });
    setSelectedActivities(tempObj);
    if (tempObj.length !== 0) {
      setSelectNextActivity(true);
    }
  };
  function getAllActivites() {
    let options = [];
    tableData?.table?.columns_new?.forEach((activity) => {
      if (activity.type === "activity" && activity.activity_type === "default") {
        options.push(activity);
      }
    });
    return options;
  }

  function multiSelectCallbackFunction(data) {
    let dataCopy = { ...ownerPreFilters };
    dataCopy.next_activities = data.map((selectedActivity) => selectedActivity.activity_id);
    setSelectedActivities(data);
    setOwnerPreFilters(dataCopy);
  }

  function handleNextActivities(checked) {
    if (checked) {
      setSelectNextActivity(checked);
    } else {
      setSelectNextActivity(checked);
      setSelectedActivities([]);
      setOwnerPreFilters({ ...ownerPreFilters, next_activities: [] });
    }
  }

  useEffect(() => {
    if (!ownerPreFilters) return;
    getNextActivities();
    setSelectedActivities(ownerPreFilters.next_activities);
    setSelectNextActivity(ownerPreFilters.next_activities.length > 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div className="mb_2">
        <label className="prefilter_label">Owner Pre-filters</label>
      </div>
      <div className="prefilter_checkbox_container">
        <Input
          type="checkbox"
          checked={ownerPreFilters?.logged_user}
          onChange={(e) => setOwnerPreFilters({ ...ownerPreFilters, logged_user: e.target.checked })}
        />
        <label className="prefilter_checkbox_label">Loggedin user is owner of any next activity (y)</label>
      </div>
      <div>
        <div className="prefilter_checkbox_container">
          <Input
            type="checkbox"
            checked={selectNextActivity}
            onChange={({ target: { checked } }) => handleNextActivities(checked)}
          />
          <label className="prefilter_checkbox_label">The next activity is one of the following activities</label>
        </div>
        {selectNextActivity && (
          <div>
            <MultiSelectBox
              options={getAllActivites()}
              onChange={multiSelectCallbackFunction}
              selectedData={selectedActivities}
              valueKey="activity_id"
              label="The next activity is one of the following activities"
            />
          </div>
        )}
      </div>
      <div className="prefilter_checkbox_container">
        <Input
          type="checkbox"
          checked={ownerPreFilters?.hide_activities}
          onChange={({ target: { checked } }) => setOwnerPreFilters({ ...ownerPreFilters, hide_activities: checked })}
        />
        <label className="prefilter_checkbox_label">Don't show other activities</label>
      </div>
    </>
  );
};

export default OwnerPreFilters;
